@if (tabs?.length && filterByUserRole(tabs).length) {
  @if (rows?.length && getFilteredRows(rows)) {
    <div [ngClass]="tableClass" [class.sidebar-open]="sidebarOpen">
      @if (!skipHeader) {
        <table-entries-header [tabs]="filterByUserRole(tabs)"
                              [tableHeaderClass]="tableHeaderClass"
                              [loading]="loading"
                              [simplified]="simplified"
                              (headerCallback)="headerCallbackHandler($event)"
                              (headerOptionalCallback)="headerOptionalCallbackHandler($event)">
        </table-entries-header>
      }
      <table-entries-body [tableBodyClass]="tableBodyClass"
                          [rows]="getFilteredRows(rows)"
                          [paginationId]="paginationId"
                          [loading]="loading"
                          [simplified]="simplified"
                          (callback)="callbackHandler($event)"
                          (buttonCallback)="buttonCallbackHandler($event)">
      </table-entries-body>
    </div>
  } @else if (!loading) {
    <p class="am-flex-center m-l">
      @if (showCustomVoidMessage()) { Es liegen keine To-Do’s vor. Informationen zu abgeschlossenen Geschäftsvorgängen finden Sie im Archiv. }
      @else                         { Es wurden keine Resultate gefunden. }
    </p>
  }
}
